<template>
  <div id="app">
    <keep-alive>
      <router-view
        v-wechat-title="$route.meta.title"
        v-if="$route.meta.keepAlive"
      />
    </keep-alive>
    <router-view
      v-wechat-title="$route.meta.title"
      v-if="!$route.meta.keepAlive"
    />
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss">
#app{
  min-height: 100vh;
  min-width: 1200px;
  overflow:auto;
}

</style>
